import { Pano } from "../Pano.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";

export class ControlVolume extends BaseControl {
    constructor(pano: Pano) {
        super(pano, ControlPosition.LEFT);

        //Volume
        this.element.classList.add("control-button", "volume");
        this.element.setAttribute("state", this._video.muted ? "mute" : "loud");
        this.element.innerHTML = `
        <div class="control-button-icon icon-498 mute"></div>
        <div class="control-button-icon icon-500 loud"></div>
        `;

        if (window.localStorage) {
            if (window.localStorage.getItem("volume")) {
                this._video.muted = window.localStorage.getItem("volume") === "true";
            }
        }

        this.element.addEventListener("click", () => {
            this._video.muted = !this._video.muted;
            if (window.localStorage) {
                window.localStorage.setItem("volume", this._video.muted + "");
            }
        });

        this.pano.video.addEventListener("volumechange", () => this.update());
    }

    private update(): void {
        this.element.setAttribute("state", this._video.muted ? "mute" : "loud");
    }
}